export default __webpack_public_path__ + "static/media/document_normal.b207a6d4.svg";